import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const TeamsPrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const TeamsSecondaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-accent)] hover:bg-white/10",
})``;

export const TeamsInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const TeamsThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const TeamsLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const TeamsMetaText = styled.p.attrs({ className: "text-xs text-[var(--brand-muted)]" })``;

export const TeamsGridLayout = styled.div.attrs({ className: "grid gap-3 md:grid-cols-4" })``;

export const TeamsFieldInput = styled.input.attrs({ className: "brand-input md:col-span-2" })``;

export const TeamsFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const TeamsDrawerForm = styled.form.attrs({ className: "space-y-5" })``;

export const TeamsDrawerStack = styled.div.attrs({ className: "space-y-3" })``;

export const TeamsDrawerActions = styled.div.attrs({
  className: "flex flex-wrap items-center justify-end gap-3 pt-2",
})``;

export const TeamsBodyText = styled.p.attrs({
  className: "text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const TeamsResultList = styled.div.attrs({
  className: "space-y-2 rounded-3xl border border-white/10 bg-white/5 p-3",
})``;

export const TeamsResultButton = styled.button.attrs({
  className:
    "flex w-full items-start justify-between gap-3 rounded-2xl border border-transparent bg-white/5 px-4 py-3 text-left transition hover:border-[var(--brand-accent)] hover:bg-white/10",
})``;

export const TeamsResultText = styled.div.attrs({ className: "min-w-0 space-y-1" })``;

export const TeamsResultMeta = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;
